import {
  DropdownType,
  getTaskList,
  AddManualTaskListType,
  postEntityMacros,
  AddManualTaskMacroType,
  useSelector,
  TASK_TYPE_IDS,
  fetchTaskEntititesDropdownOptionsApi,
} from '@app-store'
import { ControlledDropDown, CustomButton, FormInput, Modal } from '@ui-kit'
import { FC, useEffect, useState } from 'react'
import { FieldValues, useForm } from 'react-hook-form'
import { WorkflowAddManualTaskModalPropsType } from '../../types/workflow.types'
import {
  MANUAL_TASK_CONSTANTS,
  NAMESPACES,
  WORKFLOW_STATUS,
} from '../../utils/constants'
import { logErrorMessage } from '../../utils/helperFunctions'
import { RootState, useAppSelector } from '../../utils/agent.store'
import moment from 'moment'

const WorkflowAddManualTaskModal: FC<WorkflowAddManualTaskModalPropsType> = ({
  setIsAddTask,
  isAddTask,
  createTask,
}) => {
  const { id: patientId } =
    useSelector((state: RootState) => state?.workflowData?.patientData) || {}
  const {
    register,
    handleSubmit,
    control,
    setValue,
    formState: { errors },
    watch,
  } = useForm({
    defaultValues: {
      status: WORKFLOW_STATUS?.PENDING,
      taskType: '',
      taskName: '',
      taskSummary: '',
      startDate: '',
      dueDate: '',
      task: '',
      assignee: {},
      task_template: {},
      entityType: '',
      entityName: '',
      entityTypeDropdown: '',
      entityNameDropdown: '',
    },
  })

  const user = useAppSelector((store) => store?.authUser?.user)
  // const dispatch = useAppDispatch()
  const [manualTaskList, setManualTaskList] = useState<DropdownType<string>[]>(
    []
  )
  const [manualTaskTypeList, setManualTaskTypeList] = useState<
    DropdownType<string>[]
  >([])
  // const [entityOptions, setEntityOptions] = useState<DropdownType<string>[]>([])
  const [selectedTaskID, setSelectedTaskID] = useState<number>()
  const taskType = watch('taskType')
  // const PERSON_TYPE_ENTITIES = [
  //   {
  //     label: 'Patient',
  //     value: '18',
  //   },
  //   {
  //     label: 'Provider',
  //     value: '4',
  //   },
  //   {
  //     label: 'Contact',
  //     value: '998',
  //   },
  // ]

  const onSubmit = async (data: FieldValues) => {
    if (
      patientId &&
      data.task_template.id === TASK_TYPE_IDS.MANUAL_TEXT_OUTBOUND
    ) {
      const {
        data: { content: results },
      } = await fetchTaskEntititesDropdownOptionsApi({
        entityType: 'person',
        searchValue: patientId,
        //id?: patientId
        page: 0,
        size: 1,
      })
      const recordId = results[0].id
      data.requestor_view = { id: recordId }
    }
    await createTask(data)
    // reset()
    // setIsAddTask(false)
    // setRefetch(!refetch)
  }

  const handleTaskChange = (e: DropdownType<string>) => {
    setValue('task', e?.value)
    setSelectedTaskID(e?.value ? parseInt(e?.value) : undefined)
    setValue('taskName', e?.label)
  }

  const handleTaskTypeChange = (e: DropdownType<string>) => {
    setValue('taskType', e?.value)
    setValue('task_template', { id: e?.value, name: e?.label })
  }

  // const handleEntityTypeChange = async (e: DropdownType<unknown, string>) => {
  //   setValue('entityTypeDropdown', e?.value)
  //   setValue('entityType', e?.label)
  //   if (e.value === 'person') {
  //     setEntityOptions(PERSON_TYPE_ENTITIES)
  //   } else if (e.value === 'organization') {
  //     try {
  //       dispatch(showLoader())
  //       const response = await getEntityList({
  //         entity_name: 'organization_type',
  //         embedded_name: 'name',
  //       })
  //       if (response.data) {
  //         setEntityOptions(
  //           response?.data?.content?.map(
  //             (item: { id: number; name: string }) => ({
  //               label: item.name,
  //               value: item.id.toString(),
  //             })
  //           )
  //         )
  //       }
  //     } catch (err) {
  //       console.log(err)
  //     } finally {
  //       dispatch(hideLoader())
  //     }
  //   }
  // }

  useEffect(() => {
    const fetchTaskTypes = async () => {
      try {
        const response = await getTaskList()
        const taskOptions: DropdownType<string>[] = response?.data?.map(
          (task: AddManualTaskListType) => ({
            label: task?.name ?? '',
            value: task?.id ?? '',
          })
        )
        setManualTaskList(taskOptions ?? [])
      } catch (error) {
        logErrorMessage('task type', error)
      }
    }

    if (isAddTask) {
      fetchTaskTypes()
    }
  }, [isAddTask])

  useEffect(() => {
    const handlePostMacros = async () => {
      try {
        const response = await postEntityMacros(selectedTaskID as number, [
          '${t_task.t_task_t_typesm2m.name}',
        ])
        const taskOptions: DropdownType<string>[] =
          response?.data?.[0]?.t_task_t_typesm2m?.map(
            (taskType: AddManualTaskMacroType) => ({
              label: taskType?.name ?? '',
              value: taskType?.id ?? '',
            })
          )
        setManualTaskTypeList(taskOptions ?? [])
      } catch (error) {
        console.error('Error posting macros:', error)
      }
    }
    if (selectedTaskID !== undefined) {
      handlePostMacros()
    }
    if (user) setValue('assignee', { id: user?.id })
  }, [selectedTaskID])

  useEffect(() => {
    if (!taskType) {
      setValue('taskName', '')
    }
    setValue('startDate', moment().format('YYYY-MM-DDTHH:mm:ss'))
  }, [taskType])

  return (
    <Modal
      modalHeader={NAMESPACES?.ADD_TASK}
      isOpen={isAddTask}
      closeModal={() => {
        setIsAddTask(false)
      }}
      width="w-[min(50rem,calc(100vw-2rem))]"
      isResizable
      minResizeHeight={60}
      bodyCssClassName="!flex !flex-col !overflow-hidden [&_.modal-scroll-container]:!flex-1 [&_.modal-scroll-container]:!min-h-0 [&_.modal-scroll-container]:!overflow-hidden [&_.modal-body-container]:!h-full [&_.modal-body-container]:!min-h-0"
    >
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="h-full min-h-0 overflow-y-auto"
      >
        <div className="mt-4">
          <div>
            <ControlledDropDown
              onChange={handleTaskChange}
              label={NAMESPACES?.TASK_NAME}
              options={manualTaskList}
              className="mt-4"
              name={'task'}
              control={control}
              required={true}
              errors={errors}
            />
          </div>
          <div>
            <ControlledDropDown
              onChange={handleTaskTypeChange}
              label={NAMESPACES?.TASK_TYPE}
              options={manualTaskTypeList}
              className="mt-4"
              name={'taskType'}
              control={control}
              required={true}
              errors={errors}
            />
          </div>
        </div>

        <div className="flex flex-wrap gap-4 mt-4">
          <div className="min-w-[14rem] flex-1 basis-[14rem]">
            <FormInput
              name="startDate"
              label={NAMESPACES?.START_DATE}
              required
              type="datetime-local"
              register={register}
              max={moment(watch('dueDate'))?.format('YYYY-MM-DDTHH:mm:ss')}
            />
          </div>
          <div className="min-w-[14rem] flex-1 basis-[14rem]">
            <FormInput
              name="dueDate"
              label={NAMESPACES?.DUE_DATE}
              required
              type="datetime-local"
              register={register}
              min={moment(watch('startDate'))?.format('YYYY-MM-DDTHH:mm:ss')}
            />
          </div>
          <div className="min-w-[14rem] flex-1 basis-[14rem]">
            <ControlledDropDown
              name={'status'}
              label={NAMESPACES?.STATUS}
              control={control}
              options={[
                {
                  value: MANUAL_TASK_CONSTANTS?.PENDING?.value,
                  label: MANUAL_TASK_CONSTANTS?.PENDING?.label,
                },
                {
                  value: MANUAL_TASK_CONSTANTS?.COMPLETED?.value,
                  label: MANUAL_TASK_CONSTANTS?.COMPLETED?.label,
                },
                {
                  value: MANUAL_TASK_CONSTANTS?.OPEN?.value,
                  label: MANUAL_TASK_CONSTANTS?.OPEN?.label,
                },
              ]}
              onChange={(e: DropdownType<string>) => {
                setValue('status', e?.value)
              }}
              placeholder={NAMESPACES?.STATUS}
            />
          </div>
        </div>
        <div className="mt-4 flex justify-end">
          <CustomButton
            type="submit"
            isFilled
            disabled={manualTaskList?.length === 0}
          >
            {NAMESPACES?.ADD}
          </CustomButton>
        </div>
      </form>
    </Modal>
  )
}

export default WorkflowAddManualTaskModal
